import React from 'react';
import type { ToolWidgetData } from '../../../types/agentWidgets';

import { SearchDocumentsWidget } from './SearchDocumentsWidget';
import { ListDocumentsWidget } from './ListDocumentsWidget';
import { ReadDocumentWidget } from './ReadDocumentWidget';
import { GetChronologyWidget } from './GetChronologyWidget';
import { ListAnalysesWidget } from './ListAnalysesWidget';
import { ReadAnalysisWidget } from './ReadAnalysisWidget';
import { GetCaseOverviewWidget } from './GetCaseOverviewWidget';
import { TriggerAnalysisWidget } from './TriggerAnalysisWidget';
import { SearchGuidelinesWidget } from './SearchGuidelinesWidget';
import { SearchPubmedWidget } from './SearchPubmedWidget';
import { LookupAbbreviationWidget } from './LookupAbbreviationWidget';
import { LookupLimitationPeriodWidget } from './LookupLimitationPeriodWidget';
import { SearchCaseLawWidget } from './SearchCaseLawWidget';
import { CheckDrugInteractionsWidget } from './CheckDrugInteractionsWidget';
import { ChronologyTimelineWidget } from './ChronologyTimelineWidget';
import { AnalysisFindingsWidget } from './AnalysisFindingsWidget';
import { ComparisonTableWidget } from './ComparisonTableWidget';
import { KeyDatesWidget } from './KeyDatesWidget';
import { PatientSummaryWidget } from './PatientSummaryWidget';
import { EvidenceChecklistWidget } from './EvidenceChecklistWidget';
import { ReportGeneratedWidget } from './ReportGeneratedWidget';

export interface ToolWidgetProps {
  data: ToolWidgetData;
}

/**
 * Registry mapping tool widget `type` discriminants to their React components.
 * AgentToolCallIndicator uses this to render rich widgets inside expanded tool cards.
 */
export const WIDGET_REGISTRY: Record<string, React.FC<{ data: any }>> = {
  search_documents: SearchDocumentsWidget,
  list_documents: ListDocumentsWidget,
  read_document: ReadDocumentWidget,
  get_chronology: GetChronologyWidget,
  list_analyses: ListAnalysesWidget,
  read_analysis: ReadAnalysisWidget,
  get_case_overview: GetCaseOverviewWidget,
  trigger_analysis: TriggerAnalysisWidget,
  search_guidelines: SearchGuidelinesWidget,
  search_pubmed: SearchPubmedWidget,
  lookup_abbreviation: LookupAbbreviationWidget,
  lookup_limitation_period: LookupLimitationPeriodWidget,
  search_case_law: SearchCaseLawWidget,
  check_drug_interactions: CheckDrugInteractionsWidget,
};

/**
 * Registry for output widgets — rendered inline in chat messages (not inside tool call expanders).
 * These display the actual structured tool output (chronology events, analysis findings, etc.).
 */
export const OUTPUT_WIDGET_REGISTRY: Record<string, React.FC<{ data: any }>> = {
  chronology_timeline: ChronologyTimelineWidget,
  analysis_findings: AnalysisFindingsWidget,
  comparison_table: ComparisonTableWidget,
  key_dates: KeyDatesWidget,
  patient_summary: PatientSummaryWidget,
  evidence_checklist: EvidenceChecklistWidget,
  report_generated: ReportGeneratedWidget,
};
